import {observer} from "mobx-react";
import React from "react";
import {Box, Card, CardContent, Divider, Typography} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import titleImage from '../../assets/img/ba--4.png'
import aboutUsImageOne from '../../assets/img/img_aboutUs1.jpeg';
import aboutUsRelationshipsImg from '../../assets/img/aboutUsRelationships.jpeg'
import aboutUsSinceImg from '../../assets/img/aboutUsSinceImage.jpeg'
import aboutUsServiceImg from '../../assets/img/aboutUsServiceImg.jpeg'
import aboutUsComeSeeImg from '../../assets/img/aboutUsComeSeeImg.jpeg'
import aboutPiginiTraditionImg from '../../assets/img/aboutPiginiTraditionImg.jpeg'
import aboutPiginiFoundingYearsImg from '../../assets/img/aboutPiginiFoundingYearsImg.jpeg'
import aboutPiginiGinoImg from '../../assets/img/aboutPiginiGinoImg.jpeg'
import aboutPiginiPhilosophyImg from '../../assets/img/aboutPiginiPhilosophyImg.jpeg'
import aboutPiginiCraftsmanshipImg from '../../assets/img/aboutPiginiCraftsmanshipImg.jpeg'
import aboutPiginiTopQualityMateiralsImg from '../../assets/img/aboutPiginiTopQualityMateiralsImg.jpeg'
import aboutPiginiCareForDetailImg from '../../assets/img/aboutPiginiCareForDetailImg.jpeg'
import aboutPiginiSelectionImg from '../../assets/img/aboutPiginiSelectionImg.jpeg'
import aboutPiginiQoiImg from '../../assets/img/aboutPiginiQoiImg.jpeg'
import aboutPiginiUniquenessImg from '../../assets/img/aboutPiginiUniquenessImg.jpeg'
import aboutPiginiTouchImg from '../../assets/img/aboutPiginiTouchImg.jpeg'
import aboutExcelsiorExpansionImg from '../../assets/img/aboutExcelsiorExpansionImg.jpeg'
import aboutExcelsiorHeritageImg from '../../assets/img/aboutExcelsiorHeritageImg.jpeg'
import aboutExcelsiorBegginingsImg from '../../assets/img/aboutExcelsiorBegginingsImg.jpeg'
import aboutConsultationsImg from '../../assets/img/aboutConsultionsImg.jpeg'
import aboutrRentalsImg from '../../assets/img/aboutrRentalsImg.jpeg'
import aboutRepairsImg from '../../assets/img/aboutRepairsImg.jpeg'


import {useStore} from "../../stores/Store";
import TextImageComponent from "../Misc/TextImageComponent/TextImageComponent";

const textImgGridStyle = {pl: 2, pr: 2}
const imgStyle = {width: '100%', borderRadius: '12px'}

export default observer(function CompanyPage(){
    const {LanguageStore} = useStore()
    const {currentLanguageMessages} = LanguageStore;
    return (
        <Grid container sx={{justifyContent: 'center'}} rowSpacing={4}>
            <Grid xs={12}>
                <img src={titleImage} alt={'Title Image'} style={{width: '100%'}} />
            </Grid>
            <Grid container xs={12} lg={10} xl={8}>
                <Grid xs={12}>
                    <Typography textAlign={'center'} variant={'h4'}>{currentLanguageMessages.CompanyPage.AboutUs.title}</Typography>
                    <Divider />
                </Grid>
                <TextImageComponent
                    orderImage={{xs: 1, md: 1}}
                    orderText={{xs: 2, md: 2}}
                    text={currentLanguageMessages.CompanyPage.AboutUs.pAndSSwitzerland.text}
                    title={currentLanguageMessages.CompanyPage.AboutUs.pAndSSwitzerland.subtitle}
                    image={aboutUsImageOne}
                />
                <TextImageComponent
                    orderImage={{xs: 3, md: 4}}
                    orderText={{xs: 4, md: 3}}
                    text={currentLanguageMessages.CompanyPage.AboutUs.relationships.text}
                    title={currentLanguageMessages.CompanyPage.AboutUs.relationships.subtitle}
                    image={aboutUsRelationshipsImg}
                />
                <TextImageComponent
                    orderImage={{xs: 5, md: 5}}
                    orderText={{xs: 6, md: 6}}
                    text={currentLanguageMessages.CompanyPage.AboutUs.since.text}
                    title={currentLanguageMessages.CompanyPage.AboutUs.since.subtitle}
                    image={aboutUsSinceImg}
                />
                <TextImageComponent
                    orderImage={{xs: 7, md: 8}}
                    orderText={{xs: 8, md: 7}}
                    text={currentLanguageMessages.CompanyPage.AboutUs.ourService.text}
                    title={currentLanguageMessages.CompanyPage.AboutUs.ourService.subtitle}
                    image={aboutUsServiceImg}
                />
                <TextImageComponent
                    orderImage={{xs: 9, md: 9}}
                    orderText={{xs: 10, md: 10}}
                    text={currentLanguageMessages.CompanyPage.AboutUs.comeSee.text}
                    title={currentLanguageMessages.CompanyPage.AboutUs.comeSee.subtitle}
                    image={aboutUsComeSeeImg}
                />
                <Grid xs={12} order={11}>
                    <Typography textAlign={'center'} variant={'h4'}>{currentLanguageMessages.CompanyPage.AboutPigini.title}</Typography>
                    <Divider />
                </Grid>
                <TextImageComponent
                    orderImage={{xs: 12, md: 13}}
                    orderText={{xs: 13, md: 12}}
                    text={currentLanguageMessages.CompanyPage.AboutPigini.tradition.text}
                    title={currentLanguageMessages.CompanyPage.AboutPigini.tradition.subtitle}
                    image={aboutPiginiTraditionImg}
                />
                <TextImageComponent
                    orderImage={{xs: 14, md: 14}}
                    orderText={{xs: 15, md: 15}}
                    text={currentLanguageMessages.CompanyPage.AboutPigini.foundingYears.text}
                    title={currentLanguageMessages.CompanyPage.AboutPigini.foundingYears.subtitle}
                    image={aboutPiginiFoundingYearsImg}
                />
                <TextImageComponent
                    orderImage={{xs: 16, md: 17}}
                    orderText={{xs: 17, md: 16}}
                    text={currentLanguageMessages.CompanyPage.AboutPigini.ginoPigini.text}
                    title={currentLanguageMessages.CompanyPage.AboutPigini.ginoPigini.subtitle}
                    image={aboutPiginiGinoImg}
                />
                <TextImageComponent
                    orderImage={{xs: 18, md: 18}}
                    orderText={{xs: 19, md: 19}}
                    text={currentLanguageMessages.CompanyPage.AboutPigini.philosophy.text}
                    title={currentLanguageMessages.CompanyPage.AboutPigini.philosophy.subtitle}
                    image={aboutPiginiPhilosophyImg}
                />
                <TextImageComponent
                    orderImage={{xs: 20, md: 21}}
                    orderText={{xs: 21, md: 20}}
                    text={currentLanguageMessages.CompanyPage.AboutPigini.craftsmanship.text}
                    title={currentLanguageMessages.CompanyPage.AboutPigini.craftsmanship.subtitle}
                    image={aboutPiginiCraftsmanshipImg}
                />
                <TextImageComponent
                    orderImage={{xs: 22, md: 22}}
                    orderText={{xs: 23, md: 23}}
                    text={currentLanguageMessages.CompanyPage.AboutPigini.topQualityMaterials.text}
                    title={currentLanguageMessages.CompanyPage.AboutPigini.topQualityMaterials.subtitle}
                    image={aboutPiginiTopQualityMateiralsImg}
                />
                <TextImageComponent
                    orderImage={{xs: 24, md: 25}}
                    orderText={{xs: 25, md: 24}}
                    text={currentLanguageMessages.CompanyPage.AboutPigini.careForDetail.text}
                    title={currentLanguageMessages.CompanyPage.AboutPigini.careForDetail.subtitle}
                    image={aboutPiginiCareForDetailImg}
                />
                <TextImageComponent
                    orderImage={{xs: 26, md: 26}}
                    orderText={{xs: 27, md: 27}}
                    text={currentLanguageMessages.CompanyPage.AboutPigini.selection.text}
                    title={currentLanguageMessages.CompanyPage.AboutPigini.selection.subtitle}
                    image={aboutPiginiSelectionImg}
                />
                <TextImageComponent
                    orderImage={{xs: 28, md: 29}}
                    orderText={{xs: 29, md: 28}}
                    text={currentLanguageMessages.CompanyPage.AboutPigini.qoi.text}
                    title={currentLanguageMessages.CompanyPage.AboutPigini.qoi.subtitle}
                    image={aboutPiginiQoiImg}
                />
                <TextImageComponent
                    orderImage={{xs: 30, md: 30}}
                    orderText={{xs: 31, md: 31}}
                    text={currentLanguageMessages.CompanyPage.AboutPigini.uniqueness.text}
                    title={currentLanguageMessages.CompanyPage.AboutPigini.uniqueness.subtitle}
                    image={aboutPiginiUniquenessImg}
                />
                <TextImageComponent
                    orderImage={{xs: 32, md: 33}}
                    orderText={{xs: 33, md: 32}}
                    text={currentLanguageMessages.CompanyPage.AboutPigini.touch.text}
                    title={currentLanguageMessages.CompanyPage.AboutPigini.touch.subtitle}
                    image={aboutPiginiTouchImg}
                />
                <Grid xs={12} order={34}>
                    <Typography textAlign={'center'} variant={'h4'}>{currentLanguageMessages.CompanyPage.AboutExcelsior.title}</Typography>
                    <Divider />
                </Grid>
                <TextImageComponent
                    orderImage={{xs: 35, md: 35}}
                    orderText={{xs: 36, md: 36}}
                    text={currentLanguageMessages.CompanyPage.AboutExcelsior.beginnings.text}
                    title={currentLanguageMessages.CompanyPage.AboutExcelsior.beginnings.subtitle}
                    image={aboutExcelsiorBegginingsImg}
                />
                <TextImageComponent
                    orderImage={{xs: 37, md: 38}}
                    orderText={{xs: 38, md: 37}}
                    text={currentLanguageMessages.CompanyPage.AboutExcelsior.expansion.text}
                    title={currentLanguageMessages.CompanyPage.AboutExcelsior.expansion.subtitle}
                    image={aboutExcelsiorExpansionImg}
                />
                <TextImageComponent
                    orderImage={{xs: 39, md: 39}}
                    orderText={{xs: 40, md: 40}}
                    text={currentLanguageMessages.CompanyPage.AboutExcelsior.heritage.text}
                    title={currentLanguageMessages.CompanyPage.AboutExcelsior.heritage.subtitle}
                    image={aboutExcelsiorHeritageImg}
                />
                <Grid xs={12} order={41}>
                    <Typography textAlign={'center'} variant={'h4'}>{currentLanguageMessages.CompanyPage.Consultations.title}</Typography>
                    <Divider />
                </Grid>
                <Grid xs={12} md={4} sx={textImgGridStyle} order={{xs:42, md: 43}}>
                    <img src={aboutConsultationsImg} alt={'consult'} style={imgStyle} />
                </Grid>
                <Grid xs={12} md={8} sx={textImgGridStyle} order={{xs:43, md:42}}>
                    <Typography variant={'h6'}>{currentLanguageMessages.CompanyPage.Consultations.appointments.subtitle}</Typography>
                    <Typography>{currentLanguageMessages.CompanyPage.Consultations.appointments.text} {currentLanguageMessages.CompanyPage.Consultations.wideSelection.text} {currentLanguageMessages.CompanyPage.Consultations.service.text}</Typography>
                </Grid>
                <Grid xs={12} order={44}>
                    <Typography textAlign={'center'} variant={'h4'}>{currentLanguageMessages.CompanyPage.Rentals.title}</Typography>
                    <Divider />
                </Grid>
                <TextImageComponent
                    orderImage={{xs: 45, md: 45}}
                    orderText={{xs: 46, md: 46}}
                    text={currentLanguageMessages.CompanyPage.Rentals.text}
                    title={currentLanguageMessages.CompanyPage.Rentals.subtitle}
                    image={aboutrRentalsImg}
                />
                <Grid xs={12} order={47}>
                    <Typography textAlign={'center'} variant={'h4'}>{currentLanguageMessages.CompanyPage.Repairs.title}</Typography>
                    <Divider />
                </Grid>
                <TextImageComponent
                    orderImage={{xs: 48, md: 49}}
                    orderText={{xs: 49, md: 48}}
                    text={currentLanguageMessages.CompanyPage.Repairs.text}
                    title={currentLanguageMessages.CompanyPage.Repairs.subtitle}
                    image={aboutRepairsImg}
                />
            </Grid>
        </Grid>
    )
})